<template>
    <div>
        <el-tabs type="border-card" v-model="activeName">
            <el-tab-pane :key="item.name"  v-for="(item, index) in tabList" :label="item.label" :name="item.name">
                <component :is='item.content' :ref="item.content" :data="data" @close="close"v-if="activeName==item.name"></component>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import BasicInformation from './BasicInformation'
    import TransferHistory from './TransferHistory'
    export default {
        name: "DetailPage",
        components: {BasicInformation,TransferHistory},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                tabList:[
                    {label:this.$t('personInformation_basic_information'),name:'jbxx',content:'BasicInformation'},
                    {label:this.$t('personInformation_personnel_department'),name:'ydls',content:'TransferHistory'},
                    ],
                activeName:'jbxx',
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })
            if(this.data.type=='add'){
                this.tabList=[{label:this.$t('personInformation_basic_information'),name:'jbxx',content:'BasicInformation',show:true}]
            }
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            close(type='back'){
              this.$emit('close',type)
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>